/* eslint-disable */
import ConfirmModal from '../components/layout/Modal/confirmModal';

const confirmModal = {
  install(Vue, options) {
    this.EventBus = new Vue();
    Vue.component('confirm-modal', ConfirmModal);
    Vue.prototype.$confirmModal = {
      show(params) {
        confirmModal.EventBus.$emit('show', params);
      },
    };
  },
};

export default confirmModal;
